module.exports = __webpack_public_path__ + "img/icon-download.bdb8f3f3.svg";